module.exports = __webpack_public_path__ + "static/media/lf.43b8994a.jpg";